export default __webpack_public_path__ + "static/media/project-bloom-landing-banner-light.dd04d086.svg";